import React, { useState } from 'react';
import { useDroppable } from '@dnd-kit/core';
import DraggableTire from './DraggableTire';

const UnAssigned = ({ initialData, positions, onTireMove }) => {
    const { setNodeRef, isOver } = useDroppable({
        id: 'serviceBay',
        data: {
            type: 'section',
            sectionType: 'serviceBay'
        }
    });

    const [searchTerm, setSearchTerm] = useState('');

    const filteredTires = initialData?.filter((tire) =>
        `${tire.brand} ${tire.model} ${tire.size} ${tire.tin}`
            .toLowerCase()
            .includes(searchTerm.toLowerCase())
    );

    return (
        <div
            ref={setNodeRef}
            className={`w-full flex flex-col gap-4 p-4 h-full max-h-[600px] overflow-hidden ${
                isOver ? 'bg-gray-200' : ''
            }`}
        >
            <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search tire..."
                className="px-3 py-2 border rounded-md text-sm outline-none "
            />

            {filteredTires && filteredTires.length > 0 ? (
                <div className="grid grid-cols-1 gap-3 max-h-[550px] overflow-hidden overflow-y-auto">
                    {filteredTires.map((tire) => {
                        const tirePosition = {
                            id: `unassigned-${tire.tireId}`,
                            label: 'Unassigned Tire',
                            tire: tire,
                            sectionType: 'serviceBay'
                        };

                        return (
                            <DraggableTire
                                key={tire.tireId}
                                tire={tire}
                                position={tirePosition}
                            />
                        );
                    })}
                </div>
            ) : (
                <div className="flex items-center justify-center h-full text-gray-400 text-sm">
                    No tires found.
                </div>
            )}
        </div>
    );
};

export default UnAssigned;
